import { Appointment } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postSendFollowupReminderForBusiness({
  aid,
}: {
  aid: Appointment["aid"];
}): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();

    let endpoint = `${TRYST_HOST}/business/appointment/${aid}/send-followup-reminder`;
    const headers = new Headers();

    headers.append("Content-Type", "application/json");
    const res = await fetch(endpoint, {
      method: "POST",
      redirect: "follow",
      credentials: "include",
      headers,
    });

    return res.json();
  } catch (e) {
    return { success: false };
  }
}
